
import React, { useEffect, useState } from "react";
import { initCapacitor } from "@/utils/capacitor-init";
import SearchDialog from "./SearchDialog";
import NotificationsDropdown from "./NotificationsDropdown";
import { useAuth } from "@/contexts/AuthContext";
import UserMenu from "./UserMenu";

const NavActions: React.FC = () => {
  const [isNative, setIsNative] = useState(false);
  const { user } = useAuth();
  
  useEffect(() => {
    // Initialize Capacitor and check if native
    const setupCapacitor = async () => {
      try {
        const { isNative: nativeStatus } = await initCapacitor();
        setIsNative(nativeStatus);
      } catch (error) {
        console.error("Error setting up Capacitor in NavActions:", error);
        setIsNative(false);
      }
    };
    
    setupCapacitor();
  }, []);
  
  return (
    <div className="hidden md:flex items-center space-x-4">
      <SearchDialog />
      <div className="relative">
        <NotificationsDropdown />
      </div>
      {user && <UserMenu />}
    </div>
  );
};

export default NavActions;
